var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"http://ocom.com.au","target":"_blank"}},[_c('span',{staticStyle:{"color":"#f78f1e"}},[_vm._v("O")]),_c('span',{staticStyle:{"color":"#0059aa"}},[_vm._v("com"),(!_vm.short)?_c('span',[_vm._v(" Software")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }